import en from './en';
import de from './de';

export default { en, de };



// WEBPACK FOOTER //
// ./src/i18n/index.js